import { useEffect } from "react";
import { BaseTile } from "../../../../../common/components/BaseTile/BaseTile";
import "./PathUnknownTile.scss";

export interface PathUnknownTileProps {
  reqName: string;
  reqType: string;
}

/**
 * Fallback tile for unrecognised ReqTypes.
 *
 * Renders a minimal placeholder so the grid layout is preserved and no crash occurs.
 * When a future market introduces a new ReqType, this tile renders first — then a
 * proper tile component is added as an extension.
 *
 * Logs a warning to the console for debugging — visible in DevTools but not to end users.
 */
export const PathUnknownTile = ({ reqName, reqType }: PathUnknownTileProps) => {
  useEffect(() => {
    console.warn(`[LSPathView] Unknown requirement type: ${reqType} (${reqName})`);
  }, [reqName, reqType]);

  return (
    <BaseTile>
      <div className="PathUnknownTile">
        <p className="PathUnknownTile__placeholder">—</p>
      </div>
    </BaseTile>
  );
};

export default PathUnknownTile;
